// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const ShareIcon = props => <Icon {...props} dangerouslySetIcon={'<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.602 3.082a1 1 0 011.082.188l8 7.5a1 1 0 010 1.46l-8 7.5A1 1 0 0112 19v-3.635c-2.6.066-4.3.402-5.578 1.074-1.4.736-2.424 1.945-3.54 4.033A1 1 0 011 20.001c0-4.858 1.646-8.03 4.079-9.957C7.16 8.394 9.707 7.742 12 7.602V4a1 1 0 01.602-.918zM14 6.308v2.263a1 1 0 01-1 1c-2.271 0-4.769.526-6.679 2.04-1.24.982-2.296 2.433-2.867 4.574a8.2 8.2 0 012.038-1.517c1.88-.988 4.254-1.315 7.508-1.315a1 1 0 011 1v2.339l5.538-5.192L14 6.308z" fill="currentColor"/></svg>'} />;

ShareIcon.displayName = 'ShareIcon';

export default ShareIcon;
